var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.annotators.length)?_c('div',[_c('Select2',{attrs:{"options":_vm.selectOptions,"settings":{multiple: true}},on:{"select":function($event){return _vm.select($event)}},model:{value:(_vm.selectedIds),callback:function ($$v) {_vm.selectedIds=$$v},expression:"selectedIds"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }